import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../../../config/firebase-config';

export const uploadImageAndGetURL = async (imageBase64, path) => {
  if (!imageBase64 || !path) {
    console.error('Image base64 y path son requeridos');
    return null;
  }

  try {
    const fileRef = ref(storage, path);

    // Web form handlers provide File objects, while older flows may still send base64.
    if (imageBase64 instanceof Blob) {
      await uploadBytes(fileRef, imageBase64, {
        contentType: imageBase64.type || 'image/jpeg',
      });
    } else if (typeof imageBase64 === 'string') {
      const base64Payload = imageBase64.split(',')[1] || imageBase64;
      const binaryString = atob(base64Payload);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const contentTypeMatch = imageBase64.match(/^data:(.*?);base64,/);
      await uploadBytes(fileRef, bytes, {
        contentType: contentTypeMatch?.[1] || 'image/jpeg',
      });
    } else {
      console.error('Formato de imagen no soportado');
      return null;
    }

    const downloadURL = await getDownloadURL(fileRef);
    return downloadURL;
  } catch (error) {
    console.error('Error subiendo imagen:', error);
    return null;
  }
};

export const cleanupImages = async (imageURLs) => {
  if (!imageURLs || imageURLs.length === 0) {
    return;
  }

  const cleanupPromises = imageURLs.map(async (url) => {
    try {
      const decodedURL = decodeURIComponent(url);
      const startIndex = decodedURL.indexOf('/o/') + 3;
      const endIndex = decodedURL.indexOf('?');
      const filePath = decodedURL.substring(startIndex, endIndex);

      const fileRef = ref(storage, filePath);
      await deleteObject(fileRef);
      console.log(`✅ Imagen eliminada: ${filePath}`);
    } catch (error) {
      console.error(`❌ Error eliminando imagen: ${error.message}`);
    }
  });

  await Promise.all(cleanupPromises);
};
